import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "jotai";
import App from "./App";
import "./assets/css/main.css";
import { EnvConfig } from "./utils/env";
// 初始化环境配置
EnvConfig.printConfig();
const container = document.getElementById("root");
if (!container) {
    throw new Error("Root element not found");
}
const root = ReactDOM.createRoot(container);
const basename = process.env.REACT_APP_ENV === "production" ? "/datav/" : "";
root.render(_jsx(Provider, { children: _jsx(BrowserRouter, { basename: basename, children: _jsx(App, {}) }) }));
